<template>
    <div class="menu menu-sub menu-sub-dropdown w-250px w-md-300px" data-kt-menu="true">
        <div class="px-7 py-5">
            <div class="fs-5 text-dark fw-bolder">{{ $t('filters.title') }}</div>
        </div>

        <div class="separator border-gray-200"></div>

        <div class="px-7 py-5 overflow-auto max-h-300px">
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.statistic.product.specific.common.saleReport.createdAtMin') }}:</label>
                <div>
                    <el-date-picker class="w-100" v-model="filterData.common_sale_report_created_at.min" type="date" :placeholder="$t('common.chooseDate')" valueFormat="YYYY-MM-DD" :disabledDate="disabledMinDate" clearable></el-date-picker>
                </div>
            </div>
            <div class="">
                <label class="form-label fw-bold">{{ $t('filters.statistic.product.specific.common.saleReport.createdAtMax') }}:</label>
                <div>
                    <el-date-picker class="w-100" v-model="filterData.common_sale_report_created_at.max" type="date" :placeholder="$t('common.chooseDate')" valueFormat="YYYY-MM-DD" :disabledDate="disabledMaxDate" clearable></el-date-picker>
                </div>
            </div>
        </div>
        <div class="separator border-gray-200"></div>
        <div class="px-7 py-5">
            <div class="d-flex justify-content-end">
                <button type="reset" v-on:click="onReset" class="btn btn-sm btn-white btn-active-light-primary me-2" data-kt-menu-dismiss="true">{{ $t('btn.reset') }}</button>
                <button type="submit" v-on:click="onFilter" class="btn btn-sm btn-primary" data-kt-menu-dismiss="true">{{ $t('btn.apply') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "index",
    data(){
        return {
            filterData: {
                common_sale_report_created_at: {}
            }
        }
    },
    methods: {
        onReset(){
            this.filterData = {
                common_sale_report_created_at: {}
            };
            this.onFilter();
        },
        onFilter(){
            this.$emit('onFilter', this.filterData);
        },
        disabledMinDate(startDate) {
            startDate = this.$moment(startDate);
            const endDate = this.filterData.common_sale_report_created_at.max ? this.$moment(this.filterData.common_sale_report_created_at.max) : undefined;

            return endDate == undefined ? false : startDate.valueOf() > endDate.valueOf()
        },
        disabledMaxDate(endDate) {
            endDate = this.$moment(endDate);
            const startDate = this.filterData.common_sale_report_created_at.min ? this.$moment(this.filterData.common_sale_report_created_at.min) : undefined;

            return startDate == undefined ? false : startDate.valueOf() > endDate.valueOf();
        },
    }
}
</script>

<style>

</style>